// removed by extract-text-webpack-plugin
module.exports = {"scrollWrap":"style__scrollWrap___3oxak","scroll":"style__scroll___P1442","scrollSpacer":"style__scrollSpacer___1BHr3","btn":"style__btn___QSPQc","btnLabel":"style__btnLabel___1Z8Xj","line":"style__line___o5veW","lineSelected":"style__lineSelected___1177A"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-ui/components/horizontal-switch/style.css
// module id = 1347
// module chunks = 0